import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api/axiosConfig'; // Use your existing axios instance
import { toast } from 'react-toastify'; // Use your existing toast for notifications
import API_ENDPOINTS,{buildEndpoint} from '../services/api/endpoints';


const useFindOrCreateConversation = () => {
    const [isLoadingChat, setIsLoadingChat] = useState(false); // Renamed to avoid conflict
    const [chatError, setChatError] = useState(null); // Renamed to avoid conflict
    const navigate = useNavigate();

    const initiateChat = async (targetUserId) => {
        setIsLoadingChat(true);
        setChatError(null);

        try {

            const response = await api.get(buildEndpoint(API_ENDPOINTS.PANEL.CUSTOMER.MESSAGE.GET_CONVERSATION_ID,{id:targetUserId}));
            console.log("response " , response);
            console.log("response data" , response.data);
            console.log("response data data" , response.data.data);

            if ( response.data.conversation_id) {
                const conversationId = response.data.conversation_id;
                navigate(`/dashboard/messages/${conversationId}`); // Redirect to chat page
            } else {
                const errorMessage = response.data.message || 'Failed to initiate chat.';
                toast.error(errorMessage);
                setChatError(new Error(errorMessage));
            }
        } catch (err) {
            console.error("Error initiating chat:", err);
            let errorMessage = 'Failed to initiate chat due to an unexpected error.';

            if (err.response) {
                errorMessage = err.response.data.message || errorMessage;
                if (err.response.data.errors) {
                    errorMessage += ' ' + Object.values(err.response.data.errors).flat().join(' ');
                }
            } else if (err.request) {
                errorMessage = 'Network Error: No response from server. Check your connection.';
            } else {
                errorMessage = err.message;
            }
            toast.error(errorMessage);
            setChatError(new Error(errorMessage));
        } finally {
            setIsLoadingChat(false);
        }
    };

    return {
        initiateChat,
        isLoadingChat,
        chatError,
    };
};

export default useFindOrCreateConversation;